import { Injectable } from '@angular/core';
import { BaseService } from './base.service';

@Injectable()
export class TestimonialsService {

  constructor(private base: BaseService) { }

  save(data){
    return this.base.post('/api/testimonial-create', data);
  }

  onCreateTemplate(data){
    return this.base.post('/api/email/create-template', data);
  }


  editTestimonials(data){
    return this.base.post('/api/testimonial-edit', data);
  }

  deleteTestimonials(data){
    return this.base.post('/api/testimonial-delete', data);
  }

  updateTestimonials(data){
    return this.base.post('/api/testimonial-update', data);
  }

 

 
}